import { render, staticRenderFns } from "./filters-card.vue?vue&type=template&id=2d0875b8&scoped=true"
import script from "./filters-card.vue?vue&type=script&lang=js"
export * from "./filters-card.vue?vue&type=script&lang=js"
import style0 from "./filters-card.vue?vue&type=style&index=0&id=2d0875b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0875b8",
  null
  
)

export default component.exports